import * as $ from "jquery";
import "jquery-validation";
import { Observable } from 'rxjs';
import { MaskService } from './mask.service';
import { FileInputCommon } from '../component/form-components/simple/file-input/file-input-common';
import { FileListInputCommon } from '../component/form-components/list/file-list-input/file-list-input-common';
export class IFormEvent {
    event: string;
}

export class ValidationService {


    public static init() {
        ($ as any).validator.setDefaults({
            ignore: []
        });
        ($ as any).validator.addMethod("validateMask", function (value, elem) {
            if (!elem)
                return false;
            if (this.optional(elem))
                return true;
            return MaskService.validate(elem);
        });
        ($ as any).validator.addMethod("validateFiles", function (value, elem) {
            if (!elem)
                return false;
            return FileInputCommon.validate(elem);
        });
        //nem működik sajna úgy oldotta meg Gabi hogy ehhez át kellene alakítani az egész file-list-upload componens rendszert ezt most nem vizsgáljuk
        ($ as any).validator.addMethod("validateMinFileCount", function (value, elem,params) {
            if (!elem){
                return false;
            }  
            return elem.prop('files').length>=params;
            
        });
        ($ as any).validator.addMethod("MinFileCountHack", function (value, elem,params) {
            if (!elem){
                return false;
            }
            return $(params.selector).length>=params.count;
            
        });
        ($ as any).validator.addMethod("validateRequiredOne", function (value, elem,params) {
            let form = $(elem).closest('form');
            let inputNames = params.split(',');
            let valid = false;
            inputNames.forEach(element => {
                if(form.find('[name="'+element+'"]').val().toString().length>0){
                    valid=true;
                }
            });
            return valid;
        });




    }

    public static forceRevalidate(form) {
        let frm = $(form);
        let submit = frm.find("[type='submit']");
        // if (submit.length > 0)
        //     submit.prop('disabled', !(frm as any).valid());
    }


    public static setupValidation(form, rules, messages?, validationCallback?): Observable<IFormEvent> {
        $(form).removeData("validator");
        return Observable.create(observer => {
            this.initValidation(observer, form, rules, messages, validationCallback)
        });
    }

    private static submit(observer, form) {
        setTimeout(() => {
            if (($(form) as any).valid()) {
                observer.next({ event: 'submit' });
            }
            else {
                $("input, select, textarea").attr("data-dirty", 'true');
               this.scrollToInvalid();
            
            }

        }, 300)
    }

    private static scrollToInvalid() {
       
            const invalids = $('input[data-dirty=true]:not([type=hidden]).error, input.error[data-dirty=true] ~ .dropdown .dropdown-toggle, textarea[data-dirty=true].error');
            if (invalids.length > 0) {
                const top = invalids.eq(0).offset().top - 200;
                $('html, body').animate({scrollTop:top}, 400)
            }
        
    }

    public static initValidation(observer, form, rules, messages?, validationCallback?) {

        var frm = $(form);
        frm.submit(e => e.preventDefault());
        (frm as any).validate({
            rules: rules,
            messages: messages,
            ignore: [],
            submitHandler: function (form) {
                ValidationService.submit(observer, form);
            },
            invalidHandler: function () {
                observer.next({ event: 'validationFailure' });

            },
            errorPlacement: function(error, element) {
                var placement = $(element).data('error-placement');
                if (placement) {
                  $(placement).append(error)
                } else {
                  error.insertAfter(element);
                }
              }
        })
        var submit = frm.find("[type='submit']");
        if (submit.length > 0) {
            submit.click(() => {
                $("input, select, textarea").attr("data-dirty", 'true');
                ValidationService.scrollToInvalid();
            });
        }
        frm.find('input, select, textarea').on('focus input change blur', function () {
            $('input[data-dirty=true]:not(.error)').closest('.check-complete').addClass('complete');
            $('input.error').closest('.check-complete').removeClass('complete');
            if ((frm as any).valid() && (!validationCallback || (validationCallback && validationCallback()))) {
                observer.next({ event: 'validationSuccess' });
            }
            //submit.prop('disabled', !(frm as any).valid());
            //console.log((frm as any).valid());
            //submit.prop('disabled', true);
            // if (submit.length > 0) {
            //     submit.prop('disabled', !((frm as any).valid()));
            // }
        })
        this.initDirty(form);
        this.unDirty(form);

    }


    public static validateSubmit(form) {
        var frm = $(form);
        var submit = frm.find("[type='submit']");
        if (submit.length > 0) {

            submit.prop('disabled', !(frm as any).valid());
        }
    }

    public static resetForm(form) {
        $(form).find('input:not([type=radio]), textarea, select').val('');
        this.unDirty(form);
    }

    public static resetValidation() {
        ($ as any).validator.destroy()
    }


    private static initDirty(form) {
        var d = $(form).find("input, textarea, select");
        d.attr('data-dirty', 'false');
        $(form).off('blur');
        $(form).on('blur', "input, textarea, select", function () {
            $(this).attr("data-dirty", 'true');
        });
    }

    private static unDirty(form) {
        $(form).find("input[data-dirty], textarea[data-dirty], select[data-dirty]").attr('data-dirty', 'false');
    }


}